import { useNavigate } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function RankingSection() {
  const navigate = useNavigate();
  const sortedComics = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              韩漫排行
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              综合评分最高的人气韩漫作品
            </p>
          </div>
          <button
            onClick={() => {
              const allSection = document.getElementById('category-nav');
              if (allSection) {
                allSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部分类
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-5">
            {sortedComics.slice(0, 6).map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>

          <div className="bg-background-100 rounded-lg p-5 md:p-6">
            <h3 className="text-base font-medium text-foreground-900 mb-4 flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-trophy-line text-accent-500"></i>
              </div>
              韩漫人气榜 TOP 10
            </h3>
            <div className="space-y-1">
              {sortedComics.map((comic, index) => (
                <button
                  key={comic.id}
                  onClick={() => {
                    navigate(`/article/${comic.id}`);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-background-200 transition-colors cursor-pointer text-left"
                >
                  <span
                    className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                      index === 0
                        ? 'bg-accent-500 text-background-50'
                        : index === 1
                          ? 'bg-secondary-400 text-background-50'
                          : index === 2
                            ? 'bg-primary-400 text-background-50'
                            : 'bg-background-300 text-foreground-600'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-900 truncate">{comic.title}</p>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="text-[11px] text-foreground-500">{comic.author}</span>
                      <span className="text-accent-600 text-xs">{comic.rating}</span>
                    </div>
                  </div>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}